// export const BASE_URL = "http://192.168.25.115/admin/Api"
export const BASE_URL = "https://api.tabaq.in/marketing"
// export const BASE_URL = "http://localhost:8000/marketing"